export default function compose(...fns) {
  return fns.reverse().reduce(
    (acc, fn) => (x) => fn(acc(x)),
    (x) => x,
  )
}
